export default "__VITE_ASSET__rBCrPL72__"